"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_lottie_player_1 = __importDefault(require("react-lottie-player"));
const Modal_1 = __importDefault(require("@mui/material/Modal"));
function default_1({ orderPending }) {
    return ((0, jsx_runtime_1.jsx)(Modal_1.default, Object.assign({ keepMounted: true, disableScrollLock: true, open: orderPending, slotProps: { backdrop: { sx: { bgcolor: 'var(--gray-60)' } } }, sx: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: '800px',
            margin: 'auto',
        } }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_lottie_player_1.default, { path: `${process.env.CDN_URL}/assets/animations/fairy_jumping.json`, play: true, loop: true, css: { maxWidth: '500px' } }), (0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/svgs/pending_text.svg`, css: { marginTop: '-20px' } })] }) })));
}
exports.default = default_1;
